module.exports = __webpack_public_path__ + "img/Weapon_113.e5f12a0a.png";